module.exports = __webpack_public_path__ + "img/partners17.e69ef568.png";